<template>
  <div class="field-input-radio">
    <div class="input-group">
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <select
          :name="fieldData.field_name"
          :id="fieldData.field_name"
          :disabled ="!!(showDisabled())"
          v-model="fieldData.field_value"
          :aria-describedby="`${fieldData.field_name}_describedby`"
          v-validate="field_rules"
          @change="apiRule.present && apiRule.type == 'onchange' ? postRule($event.target.value, fieldData) :  ''"
          @blur="apiRule.present && apiRule.type == 'onblur' ? postRule($event.target.value, fieldData) :  ''"
          v-bind:class="{'form-control': true,
          'error': errors.has(fieldData.field_name)  || fieldData.has_error }">
          <option v-if="fieldData.placeholder" value="">{{ fieldData.placeholder }}</option>
          <option
          v-html="item.display_value"
          v-for="(item, i) in fieldData.values" :key="i"
          :id="getOptionId(fieldData, item)"
          :value="item.internal_value">
           <!-- {{ item.display_value }} -->
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  mixins: [inputFieldMixin],
  methods: {
    getOptionId(fieldRow, itemData) {
      if (fieldRow.field_name === 'stateProductFilters') {
        return `state_option_item_${itemData.internal_value}`;
      }
      if (fieldRow.field_name === 'agentProductFilters') {
        return `agent_option_item_${itemData.internal_value}`;
      }
      if (fieldRow.field_name === 'carrierProductFilters') {
        return `carrier_option_item_${itemData.internal_value}`;
      }
      if (fieldRow.field_name === 'carrierSalesProductFilters') {
        return `carriersales_option_item_${itemData.internal_value}`;
      }
      if (fieldRow.field_name === 'stateDateFilters') {
        return `state_option_item_${itemData.internal_value}`;
      }
      if (fieldRow.field_name === 'agentDateFilters') {
        return `agent_option_item_${itemData.internal_value}`;
      }
      if (fieldRow.field_name === 'carrierDateFilters') {
        return `carrier_option_item_${itemData.internal_value}`;
      }
      if (fieldRow.field_name === 'carrierSalesDateFilters') {
        return `carriersales_option_item_${itemData.internal_value}`;
      }
      return `option_item_${itemData.internal_value}`;
    },
    answerIt(name, answer) {
      if (this.fieldData.field_name === name) {
        this.selectChosen = answer;
        this.optionChosen = answer;
        this.fieldData.field_value = answer.value;
      }
    },
  },
  mounted() {
    this.$root.$on('answer-it', this.answerIt);
  },
};
</script>

<style scoped>
/*
  TODO: Add IE/Edge support by implementing the `label.btn` styles via JavaScript. Bootstrap adds classes
  'focus' and 'active' to the radio <input>'s "closest" element, which happens to be the <label>.
  See https://github.com/twbs/bootstrap/blob/7c7a1706c348fcb5290a63d9249e0c8e4b6ebbcf/js/src/button.js#L153 .
*/
label.btn:focus-within {
  color: #fff;
  background-color: #001a33;
  border-color: #001326;
  z-index: 1;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
}
select.form-control {
    height: auto !important;
    min-height: 25px;
}
select, option {
  font-family: 'Font Awesome\ 5 Free', 'Open Sans';
  font-style: normal;
  font-weight: 900;
}
.input-group {
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputSelectNt.vue?3479e7a1